var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolidity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 523.9 812.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.8;}.cls-1,.cls-2,.cls-3{fill:#fff;isolation:isolate;}.cls-2{opacity:.6;}.cls-3{opacity:.45;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-3",
    d: "M391.93,0l-130.7,232.3H0L130.61,0H391.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "cls-2",
    d: "M261.23,232.3h261.32L391.93,0H130.61l130.61,232.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    className: "cls-1",
    d: "M130.61,464.51l130.61-232.21L130.61,0,0,232.3l130.61,232.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    className: "cls-3",
    d: "M131.88,812.97l130.7-232.3h261.32l-130.7,232.3H131.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    className: "cls-2",
    d: "M262.58,580.67H1.27l130.61,232.3H393.19l-130.61-232.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    className: "cls-1",
    d: "M393.2,348.45l-130.61,232.21,130.61,232.3,130.7-232.3-130.7-232.21Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidity);
export default __webpack_public_path__ + "static/media/solidity.e0f2884a14cd1f9f71d08508d72a8224.svg";
export { ForwardRef as ReactComponent };